import { createFileRoute } from "@tanstack/react-router";
import { GoRedirect } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/go/$code/")({
  head: () => seoHead({ title: "Redirecting...", noindex: true }),
  component: GoRedirect,
});
